import demoData from './demoAccount.json';

export const DEMO_ACCOUNT_ID = '1';

export const isDemoAccount = (accountId: string | undefined): boolean => {
  return accountId === DEMO_ACCOUNT_ID;
};

export const getDemoAccountData = () => demoData.accountData;
export const getDemoFundsTransactions = () => demoData.funds.transactions;
export const getDemoOrders = () => demoData.orders;
export const getDemoAccount = () => demoData.account;
